import { useState } from 'react';
import { Icon } from '../Icon';

type TrackingNumberProps = {
  shippingTrackingNumber: string;
};

const TrackingNumber = (props: TrackingNumberProps) => {
  const { shippingTrackingNumber } = props;
  const [open, setOpen] = useState<boolean>(false);

  const popupOpen = () => {
    setOpen(true);
  }

  const onClose = () => {
    setOpen(false);
  };

  const showTrack = () => window.open(`http://nplus.doortodoor.co.kr/web/detail.jsp?slipno=${shippingTrackingNumber}`, '_blank');

  return (
    <>
      {open && (
        <div className="z-50 fixed inset-0 bg-littleblack flex items-center justify-center px-4 ">
          <div className=" w-116 flex flex-col  bg-white p-6 space-y-4 overflow-y-auto">
            <div className="flex flex-row justify-between ">
              <p className="text-18 font-medium">배송조회</p>
              <button
                onClick={onClose}
                className="flex flex-row space-x-2 items-center">
                <Icon.X />
              </button>
            </div>

            <iframe
              title="배송조회"
              src={`http://nplus.doortodoor.co.kr/web/detail.jsp?slipno=${shippingTrackingNumber}`}
              style={{width: 640, height: 480}}
            />
          </div>
        </div>
      )}
      <button type="button" onClick={showTrack}>
        <p className="text-blue-500 underline text-13">
          {shippingTrackingNumber}
        </p>
      </button>
    </>
  );
};

export default TrackingNumber;
